import { Component, OnInit } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from "src/app/_services/platform.service";
import { removeInitScreen } from "../../../_helpers/appLoading";
import { AuthenticationService } from "../../../_services";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.page.html",
  styleUrls: ["./privacy-policy.page.scss"],
})
export class PrivacyPolicyPage implements OnInit {
  isProtected: boolean;

  constructor(
    private menu: MenuController,
    private authenticationServ: AuthenticationService,
    public p: ThisPlatform,
    private headerServ: HeaderService,
  ) {}


  ngOnInit() {
    
    this.isProtected = !!this.authenticationServ.currentUserValue;
    
    this.menu.enable(this.isProtected);
    removeInitScreen();
  }
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit({
      title: "LEGAL.PRIVACY_POLICY",
      showToggleMenuButton: true,
    });
  }
}